const StepHeader = ({ step = 1, totalSteps = 3 }) => {
  return (
    <div style={headerStyles.wrapper}>
      <div style={headerStyles.barContainer}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            style={{
              ...headerStyles.bar,
              backgroundColor:
                index < step ? "#F6A21A" : "#2F3847",
            }}
          />
        ))}
      </div>

      <div style={headerStyles.stepText}>
        Step {step}/{totalSteps}
      </div>
    </div>
  );
};

export default StepHeader;

const headerStyles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
    width: "100%",
  },

  barContainer: {
    display: "flex",
    gap: 16,
    width: "88%",          // 🔥 IMPORTANT
  },

  bar: {
    height: 16,            // 🔥 thick like your image
    width: "100%",         // 🔥 ensures visibility
    borderRadius: 9999,
  },

  stepText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: 700,
    minWidth: 80,
    textAlign: "right",
  },
};

